<template>
  <div class="star-rating">
    <ion-text
      class="star-rating__title"
      v-if="readonly"
    >
      {{ modelValue?.toFixed(1) }}
    </ion-text>
    <div v-if="single" class="stars">
      <div
        class="star"
        :class="{ 'star__big': big, 'star--semi': +modelValue.toString().split('.')[1] > 0 }"
      >
        <ion-icon class="star__icon star__icon--default" src="/assets/icon/star-circuit.svg" />
        <div class="star__inner">
          <ion-icon
            class="star__icon star__icon--active"
            src="assets/icon/star.svg"
          />
        </div>
      </div>
    </div>
    <div v-else class="stars">
      <div
        class="star"
        :class="{ 'star__big': big, 'star--semi': i < modelValue + 1 && i > modelValue }"
        :key="i"
        v-for="i in 5"
        @click="!readonly && onStarClick(i)"
      >
        <ion-icon class="star__icon star__icon--default" src="/assets/icon/star-circuit.svg" />
        <div class="star__inner">
          <ion-icon
            class="star__icon star__icon--active"
            v-if="i < modelValue + 1"
            src="assets/icon/star.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { EventNamesEnum } from "@/const/events";
import { IonIcon, IonText } from "@ionic/vue";

withDefaults(
  defineProps<{
  modelValue: number;
  readonly?: boolean;
  single?: boolean;
  big?: boolean;
}>(),
  {
    single: false,
    big: false,
  }
);

const emit = defineEmits<{
  (e: EventNamesEnum.OnUpdateModelValue, rating: number): void;
}>();

function onStarClick(i: number) {
  emit(EventNamesEnum.OnUpdateModelValue, i);
}
</script>

<style lang="scss" scoped>
.star-rating {
  display: flex;
  align-items: center;

  &__title {
    display: block;
    margin-right: 4px;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: var(--ion-color-dark);
  }
}

.stars {
  display: flex;
  justify-content: center;
}

.star {
  position: relative;
  font-size: 15px;
  line-height: 1;
  width: 1em;
  height: 1em;

  &__big {
    font-size: 37px;
  }

  &__inner {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    .star--semi & {
      width: 50%;
    }
  }

  &__icon {
    position: absolute;
    left: 0;
    top: 0;
    width: 1em;
    height: 1em;
    color: var(--star-color, var(--ion-color-primary));

  }
}
</style>
